import React, { Fragment, useContext } from "react";
import { EventGalleryContext } from "./index";
import { OrgDownloadContext } from "../OrganizationPhotos/OrgDownloadContext";
import { Photo } from "./types";
import SaveIcon from "./vectors/SaveIcon";
import ISOToDateTimeFormat from "../../utils/ISOToDateTimeFormat";
import HideIcon from "./vectors/HideIcon";
import HideCancel from "./vectors/HideCancel";
import { securedEventPath } from "../../utils/pathUtils";
const phIcon = require("./images/camera.svg");

const LightBoxFooter = ({
  photo,
  isAuthorizedForDirectDownloads,
  userId,
  photoSaved,
  handleSave,
  handleUnsave,
  primaryColor,
  processedColorTheme,
  processedColorThemeBorder,
  defaultHidden,
  setCurationApiCalled,
  curatePhoto,
  isEmbed,
  cartId,
  eventClickable,
  secureAccessToken
}: {
  photo: Photo;
  isAuthorizedForDirectDownloads: boolean;
  userId?: number;
  photoSaved: boolean;
  handleSave: () => void;
  handleUnsave: () => void;
  primaryColor?: string;
  processedColorTheme: string;
  processedColorThemeBorder: string;
  defaultHidden: boolean;
  setCurationApiCalled: Function;
  curatePhoto: Function;
  isEmbed: boolean;
  cartId: string;
  eventClickable?: boolean;
  secureAccessToken?: string;
}) => {
  const eventGalleryContext = useContext(EventGalleryContext);
  const orgDownloadContext = useContext(OrgDownloadContext);

  const canDownloadPhotos =
    eventGalleryContext.isAuthorizedForDirectDownloads ||
    isAuthorizedForDirectDownloads;

  const toggleSave = () => (photoSaved ? handleUnsave() : handleSave());

  const hidePhotographersFilter = () =>
    eventGalleryContext.hidePhotographersFilter ||
    photo.hidePhotographersFilter;

  const eventAvailable = eventGalleryContext.event || photo.album.event;

  const eventPath = (event: Event) => {
    return securedEventPath({
      browsePhotosPath: eventAvailable.browsePhotosPath,
      organizerUserName:
        (orgDownloadContext && orgDownloadContext.organizerUserName) || "",
      embedMode: isEmbed,
      cartId: cartId,
      secureAccessToken:
        (orgDownloadContext && orgDownloadContext.secureAccessToken) ||
        secureAccessToken ||
        ""
    });
  };

  return (
    <div className="dv-imgdetails-foot-wrap">
      <div className="dv-imgdetails-text">
        <div className="dv-img-ph-details">
          <a
            className="geo-ph-eve-details"
            href={eventClickable ? eventPath(eventAvailable) : "#"}
          >
            {eventAvailable.name} <i className="fa fa-angle-right"></i>
          </a>
          <div className="geo-ph-details">
            {!hidePhotographersFilter() && photo.album.photographerName && (
              <p className="geo-lt__phname">
                <img src={phIcon} />{" "}
                <a
                  href={`mailto:${photo.album.photographerEmail}?cc=support@geosnapshot.com&subject=Customer contact about event: ${photo.album.eventName}`}
                >
                  {photo.album.photographerName}{" "}
                  <i className="fa fa-angle-right"></i>
                </a>
              </p>
            )}
            {photo.dateTimeTaken && (
              <span className="geo-timeTaken">
                {ISOToDateTimeFormat(photo.dateTimeTaken)}
              </span>
            )}
          </div>
        </div>
        <div
          className="download-save-btns"
          style={{ justifyContent: "flex-end" }}
        >
          {canDownloadPhotos ? (
            <Fragment>
              <button
                data-toggle="tooltip"
                data-placement="bottom"
                className="save-btn"
                onClick={() => toggleSave()}
                style={{
                  border: `1px solid ${processedColorThemeBorder}`
                }}
              >
                <SaveIcon
                  color={
                    photoSaved
                      ? "gray"
                      : processedColorTheme
                  }
                />
              </button>
              <a
                href={`/api/v1/photos/${photo.id}/download`}
                target="_blank"
                className="btn btn-primary btn-download-on-img"
                style={{
                  backgroundColor: processedColorTheme
                }}
              >
                <span
                  className="fa fa-download"
                  style={{
                    color: "white"
                  }}
                />
              </a>
            </Fragment>
          ) : null}
          {eventGalleryContext.curationMode && (
            <button
              className="geo-icon-btn-styling"
              onClick={() => (curatePhoto(), setCurationApiCalled(true))}
            >
              {defaultHidden ? (
                <HideIcon
                  color={eventGalleryContext.pageConfiguration.primaryColor}
                  width={40}
                />
              ) : (
                <HideCancel
                  color={eventGalleryContext.pageConfiguration.primaryColor}
                  width={40}
                />
              )}
            </button>
          )}
        </div>
      </div>
      <a
        className="geo-report__mbtn"
        target="_blank"
        href={photo.reportPhotoPath}
      >
        <i className="fa fa-flag"></i> <u>Report Content</u>
      </a>
    </div>
  );
};

export default LightBoxFooter;
